import CustomModal from '../../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import Icon from '../../../baseComponents/gui/icon/Icon';
import AppLoader from '../../../features/appLoader/AppLoader';
import Picture from '../../../baseComponents/gui/picture/Picture';
import useStateControls from '../../../../hooks/useStateControls';
import { useModal } from '../../../../hooks/useModal';
import { defaultStore, stores, useTranslation } from '../../../../translations';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';
import { convertorModalsContent } from '../constants/modals';
import { useHandleConvert } from '../model/hooks/useHandleConvert';
import { useConvertToCoinsData } from '../../../../redux/reducer/content';
import { useUser } from '../../../../redux/reducer/user';
import { REWARD_VALUE, REWARD_VALUE_KZ } from '../constants/values';
import { Actions, content } from '../constants/content';

const { title, description, icons: converterIcons, note, rules, buttons } = content;

export function ConverterToCoinsModal() {
  const { profile } = useUser();
  const { proportion } = useConvertToCoinsData();
  const { addModal } = useModal();

  const { convertToCoins } = useApplicationCallbacks();
  const stateCallbacks = useStateControls();

  const { t } = useTranslation();

  const isCanConvert = profile.gacha_event_cash >= proportion;

  const openRulesModal = () => addModal(convertorModalsContent({ customCallbacks: stateCallbacks }));

  const callbacks = {
    [Actions.CONVERT]: convertToCoins,
  };

  const isPending = useHandleConvert();

  return (
    <CustomModal>
      <div className={'converter-modal-to-coins'}>
        <div className={'converter-modal-to-coins__bg'} />
        <div className={'converter-modal-to-coins__content'}>
          <h2 className={'converter-modal-to-coins__title'}>{t(title)}</h2>
          <p className={'converter-modal-to-coins__text'}>{t(description)}</p>
          <p className={'converter-modal-to-coins__gifts'}>{`${t('giftConverterContent.balance')}: ${
            profile.gacha_event_cash
          }`}</p>
          <p className={'converter-modal-to-coins__note'}>{t(isCanConvert ? note.isAvailable : note.isUnavailable)}</p>
          <div className={'converter-modal-to-coins__converter'}>
            <div className={'converter-modal-to-coins__input'}>
              <div className={'converter-modal-to-coins__input-image'}>
                <Picture {...converterIcons.gift} />
              </div>
              <div className={'converter-modal-to-coins__input-value'}>{proportion}</div>
            </div>
            <div className={'converter-modal-to-coins__arrow'}>
              <Icon name={'arrow-right'} />
            </div>
            <div className={'converter-modal-to-coins__result'}>
              <div className={'converter-modal-to-coins__result-image'}>
                <Picture {...converterIcons.bonuses} />
              </div>
              <div className={'converter-modal-to-coins__result-value'}>
                {defaultStore !== stores.kz ? REWARD_VALUE : REWARD_VALUE_KZ}
              </div>
            </div>
          </div>

          <CustomButton
            className={'converter-modal-to-coins__warning'}
            onClick={openRulesModal}
            text={'giftConverterContent.link'}
            mods={['link', 'transparent']}
          />

          <div className={`converter-modal-to-coins__buttons`}>
            {buttons.map((button) => {
              const { action, ...rest } = button;
              const extraAttrs = calculateButtonProps(button, isCanConvert);

              return (
                <CustomButton
                  key={action}
                  onClick={callbacks[action]}
                  {...extraAttrs}
                  {...rest}
                  customCallbacks={stateCallbacks}
                />
              );
            })}
          </div>
        </div>
      </div>

      {isPending && <AppLoader />}
    </CustomModal>
  );
}

function calculateButtonProps({ action, attr }, isCanConvert) {
  const extraAttrs = { [Actions.CONVERT]: { ...(!isCanConvert ? { disabled: true } : {}) } }[action] ?? {};
  return { ...attr, ...extraAttrs };
}
